<template>
  <v-layout justify-center row wrap>
    <v-flex xs12>
      <v-tabs v-model="activeTab" height="100" fixed-tabs color="transparent" icons-and-text>
        <v-tabs-slider color="green" />

        <v-tab v-for="tab in tabsFiltred" :key="tab.name" exact :to="tab.route">
          {{ tab.name }}
          <v-icon>{{ tab.icon }}</v-icon>
        </v-tab>
      </v-tabs>

      <slot name="body" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

// @vuese
// @group Components/Material
// Zakładki
export default {
  props: {
    // Lista zakładek
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeTab: this.$route.path
    };
  },

  methods: {
    tabPermissions(tab) {
      if (tab.entityType && tab.entityId) {
        return tab.permission.map(permission => `${permission}:${tab.entityType}:${tab.entityId}`);
      }
      return tab.permission;
    }
  },

  computed: mapState({
    // Działa jak OR
    tabsFiltred(state) {
      const checkedPermissions = state.access.checked;
      return this.tabs.filter(tab => this.tabPermissions(tab).some(perm => checkedPermissions[perm]));
    }
  }),
  beforeMount() {
    this.$store.dispatch('access/check', this.tabs.map(tab => this.tabPermissions(tab)).flat());
  }
};
</script>
